import { get } from 'lodash';
import uiSelector from 'services/UI/selectors';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { PATH_LOADING } from './constants';
import { ILoyaltySetting } from './types/setting';

export type MyState = RootState['shop'];

export type IShopState = MyState;

export const getCurrentState = (state: RootState): MyState => state['shop'];

export const getPureStoreData = (root: RootState) => {
  const state = getCurrentState(root);
  return ({
    categories: state?.categories ?? [],
    staffs: state?.staffs ?? [],
    customers: state?.customers ?? [],
  });
};

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getCategories = () => selector('categories') as MyState['categories'];

const pureData = {
  allSetting: (root: RootState) => getCurrentState(root).allSetting as MyState['allSetting'],
};

const data = {
  categories: () => selector('categories') as MyState['categories'],
  staffs: () => selector('staffs') as MyState['staffs'],
  staffsAvailable: () => selector('staffsAvailable') as MyState['staffsAvailable'],
  customers: () => selector('customers') as MyState['customers'],
  recentCustomers: () => selector('recentCustomers') as MyState['recentCustomers'],
  shopInfo: () => selector('shopInfo') as MyState['shopInfo'],
  specialDiscounts: () => selector('specialDiscounts') as MyState['specialDiscounts'],
  coupons: () => selector('coupons') as MyState['coupons'],
  discountSetting: () => selector('discountSetting') as MyState['discountSetting'],
  orderPaymentMethods: () => selector('orderPaymentMethods') as MyState['orderPaymentMethods'],
  allSetting: () => selector('allSetting') as MyState['allSetting'],
  getLoyaltySetting: () => selector('allSetting' + '.' + 'loyaltySetting', null) as ILoyaltySetting | null,
  checkInOnlineLink: () => selector('checkInOnlineLink') as MyState['checkInOnlineLink'],

  productCategories: () => selector('productCategories') as MyState['productCategories'],
  productsVIP: () => selector('productsVIP') as MyState['productsVIP'],
  totalStation: () => selector('totalStation') as MyState['totalStation'],
  scheduleBooking: () => selector('scheduleBooking') as MyState['scheduleBooking'],
  couponPrint: () => selector('couponPrint') as MyState['couponPrint'],
  feeCreditCard: () => selector('feeCreditCard') as MyState['feeCreditCard'],
  taxConfig: () => selector('taxConfig') as MyState['taxConfig'],
  productTaxConfig: () => selector('productTaxConfig') as MyState['productTaxConfig'],
  simpleMenu: () => selector('simpleMenu') as MyState['simpleMenu'],
  simpleMenuConfigCheckIn: () => selector('simpleMenuConfigCheckIn') as MyState['simpleMenuConfigCheckIn'],
  optionTips: () => selector('optionTips') as MyState['optionTips'],
  optionTipsAll: () => selector('optionTipsAll') as MyState['optionTipsAll'],
  quickBookingService: () => selector('quickBookingService') as MyState['quickBookingService'],
  showModalTip: () => {
    const allSetting = selector('allSetting');
    if (allSetting?.showModalTip === false) return false;
    return true;
  },
  versionUI: () => selector('versionUI') as MyState['versionUI'],
  staffsAvailableBooking: () => selector('staffsAvailableBooking') as MyState['staffsAvailableBooking'],
  printCheckSetting: () => selector('printCheckSetting') as MyState['printCheckSetting'],
  settingReferral: () => selector('settingReferral') as MyState['settingReferral'],
  loyaltyRedeemConfig: () => selector('loyaltyRedeemConfig') as MyState['loyaltyRedeemConfig'],
  agreementData: () => selector('agreementData') as MyState['agreementData'],
  getListHideFieldReport: () => selector('hideFieldReport') as MyState['hideFieldReport'],
  cleaningFee: () => selector('cleaningFee') as MyState['cleaningFee'],
  anybody: () => selector('anybody') as MyState['anybody'],
};

const loading = {
  categories: () => uiSelector.getLoading(PATH_LOADING.getCategories) as boolean,
  getCategoriesWithoutBE: () => uiSelector.getLoading(PATH_LOADING.getCategoriesWithoutBE) as boolean,
  productCategories: () => uiSelector.getLoading(PATH_LOADING.getProductCategories) as boolean,
  staffs: () => uiSelector.getLoading(PATH_LOADING.getStaffList) as boolean,
  customers: () => uiSelector.getLoading(PATH_LOADING.getCustomerList) as boolean,
  productsVIP: () => uiSelector.getLoading(PATH_LOADING.getProductsVIP) as boolean,
  simpleMenu: () => uiSelector.getLoading(PATH_LOADING.getSimpleMenu) as boolean,
};

const shopSelectors = {
  data,
  pureData,
  loading,
  getCategories,
  getListHideFieldReport: data.getListHideFieldReport,
};
export default shopSelectors;
